// extracted by mini-css-extract-plugin
export var filterIncDec = "_37-0";
export var leftBorder = "_37-1";
export var rightBorder = "_37-2";
export var stringInput = "_37-3";